module.exports = __webpack_public_path__ + "img/12.8d73ed01.png";